"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRatingAndReviewSchema = void 0;
var _zod = require("zod");
const getRatingAndReviewSchema = formatMessage => _zod.z.object({
  author: _zod.z.string().trim().min(1, {
    message: formatMessage('nameOrAliasRequired')
  }),
  reviewText: _zod.z.string().trim().optional(),
  productCode: _zod.z.string().trim(),
  pros: _zod.z.array(_zod.z.string().trim()),
  cons: _zod.z.array(_zod.z.string().trim()),
  score: _zod.z.number().min(1, {
    message: formatMessage('clickOnStars')
  }).max(5)
});
exports.getRatingAndReviewSchema = getRatingAndReviewSchema;
